// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { MDBCol, MDBIcon, MDBRow } from 'mdbreact';
import FilePreviewElement from '../../layout/FilePreviewElement';
import getFileInfo from '../../../utils/getFileInfoForDisplay';

const DocumentSection = ({
  userType,
  workOrderId,
  documents,
  uploadDocument,
  deleteUpload,
  toggleModal,
  isWorkOrderCanceled,
  contractorId,
  documentVisibility
}) => {
  const handleFileUpload = (event) => {
    const { files } = event.target;
    const fd = new FormData();
    if (files) {
      fd.append('workOrderId', workOrderId);
      Array.from(files).forEach(file => {
        fd.append('files', file);
      });
      toggleModal(
        true,
        'confirmModal',
        true,
        {
          onAccept: () => {
            const visibilitiItems = {}
            Object.values(files).forEach((f) => {
              visibilitiItems[encodeURIComponent(`${f.name}`).replace(/\./g, '%2E')] = true
            })
            fd.append('documentVisibility', JSON.stringify(visibilitiItems))
            uploadDocument(fd);
          },
          header: 'Make this document viewable to the contractor prior to assignment?',
          buttonLabels: { reject: 'No' },
          onReject: () => {
            const visibilitiItems = {}
            Object.values(files).forEach((f) => {
              visibilitiItems[encodeURIComponent(`${f.name}`).replace(/\./g, '%2E')] = false
            })
            fd.append('documentVisibility', JSON.stringify(visibilitiItems))
            uploadDocument(fd);
          }
        },
      );
    }
  };

  const getConfirmToDeleteDocument = index => {
    toggleModal(
      true,
      'confirmModal',
      true,
      {
        onAccept: () => deleteFile(index),
        header: 'Are you sure you want to delete this file?',
        buttonLabels: { reject: 'Cancel' },
      },
    );
  };

  const deleteFile = index => {
    deleteUpload(documents[index], workOrderId);
  };

  return (
    <div className="add_btns">
        <div>
          {
            userType === 'client' && !isWorkOrderCanceled
              ? (
                  <label
                    className="standard_btn icon_upload"
                  >
                    <input
                      type="file"
                      className="form-control font11 full-width no-paddings"
                      style={{
                        height: '100%',
                      }}
                      multiple
                      placeholder="Upload file"
                      onChange={handleFileUpload}
                    />
                      Drag and drop your file here or click here to add file
                  </label>
              )
              : <></>
          }
        </div>
        <div>
          {
            documents?.map((data, i) => FilePreviewElement({
              fileInfo: getFileInfo(data),
              index: i,
              data,
              userType,
              toggleModal,
              contractorId,
              documentVisibility,
              removeImage: userType === 'client'
                ? getConfirmToDeleteDocument
                : false,
            }))
          }
        </div>
    </div>
  );
};

export default DocumentSection;
